import React, { useState } from "react";

const NavItem = ({ id, icon, text }) => {
  const [activeNav, setActiveNav] = useState("#home");

  return (
    // <li className="nav__item">
    //   <a href={id} className="nav__link">
    //     <i className={`uil ${icon} nav__icon`}></i>
    //     {text}
    //   </a>
    // </li>

    <li className="nav__item">
      <a
        href={id}
        onClick={() => setActiveNav(id)}
        className={activeNav === id ? "nav__link active-link" : "nav__link"}
      >
        <i className="uil uil-estate nav__icon"></i>
        {text}
      </a>
    </li>
  );
};

export default NavItem;
